function Cart(props) {
  return <h1>Giỏ hàng</h1>;
}

export default Cart;
